import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { ICategoryDetailResponse, ICategoryDetailResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useCategoryDetailAPI = () => {
  const [categoryDetail, setCategoryDetail] = useState<ICategoryDetailResponseData>({
    id: "",
    category_name: "",
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(INVENTORY_MODULE?.CATEGORY_DETAIL?.baseURL + `${id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<ICategoryDetailResponse>) => {
            if (res.data.status === true) {
              setCategoryDetail(res.data.data);
            } else {
              setCategoryDetail(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        setCategoryDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, categoryDetail };
};
